import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";

interface IcdMismatchResponse {
  data: {
    icd10CodeMismatch: boolean;
  };
}

function useGetIcdMismatch(
  icdCodes: number[],
  enabled: boolean = true
) {
  const { authState } = useOktaAuth();

  return useQuery({
    queryKey: ["icdMismatch", icdCodes],
    queryFn: () => {
      const codesParam = icdCodes.map((code) => Number(code)).join(",");
      return axiosInstance.get<IcdMismatchResponse>(
        `/v1/test-type/icd10-verification?icd10Code=${codesParam}`,
        {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        }
      );
    },
    enabled: enabled && icdCodes.length > 0,
    select: (response) => response.data?.data?.icd10CodeMismatch ?? false,
  });
}

export default useGetIcdMismatch;
